// extracted by mini-css-extract-plugin
module.exports = {"reportReasonWrap":"style_reportReasonWrap__N2zXy","reportReason":"style_reportReason__I7jG0","title":"style_title__AYVey","buttonWrap":"style_buttonWrap__lrXT4"};